import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { OpenESignatureDocumentCommandHandler } from './open-esignature-document-command-handler.service';
import { esignatureErrandCommand } from '../../command/esignature-errand.command';
import { CancelESignErrandCommandHandler } from './cancel-esign-errand-command-handler.service';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';

@Injectable()
export class ESignatureErrandCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    createHandler: CreateCommandHandler,
    openEsignDocument: OpenESignatureDocumentCommandHandler,
    cancelESignErrand: CancelESignErrandCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(esignatureErrandCommand.openESignatureDocument, openEsignDocument);
    this.addHandler(esignatureErrandCommand.cancelESignatureErrand, cancelESignErrand);
  }
}
